var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 0.125H4.75V1.625H9.25V0.125ZM6.25 9.875H7.75V5.375H6.25V9.875ZM12.2725 4.9175L13.3375 3.8525C13.015 3.47 12.6625 3.11 12.28 2.795L11.215 3.86C10.0525 2.93 8.59 2.375 7 2.375C3.2725 2.375 0.25 5.3975 0.25 9.125C0.25 12.8525 3.265 15.875 7 15.875C10.735 15.875 13.75 12.8525 13.75 9.125C13.75 7.535 13.195 6.0725 12.2725 4.9175ZM7 14.375C4.0975 14.375 1.75 12.0275 1.75 9.125C1.75 6.2225 4.0975 3.875 7 3.875C9.9025 3.875 12.25 6.2225 12.25 9.125C12.25 12.0275 9.9025 14.375 7 14.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.caec3b4f9da052ef8944535415a4b55d.svg";
export { ForwardRef as ReactComponent };